var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('h5',[_vm._v("© Secretaria Municipal de Saúde Pública - Campo Grande - MS, "+_vm._s(_vm.ano))])])}
var staticRenderFns = []

export { render, staticRenderFns }